import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import storage from '../../../utils/storage';

const AccessControl = (props) => {
    const navigate = useNavigate();

    useEffect(() => {
        const token = storage.get('token');
        if (!token) {
            navigate('/login', { replace: true });
        }
    }, [navigate]);

    return React.cloneElement(props.children);
};

export default AccessControl;
